import { createContext } from "react";

export const FooterContext = createContext();
